import requests from "@/api/axios";

export async function get_bg_color() {
    return await requests.get("web/bg_colors")
}

export async function get_clothes() {
    return await requests.get("web/clothes")
}